import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import { useGenerateIncentiveOfferPurchaseContractModal } from '../context/GenerateIncentiveOfferPurchaseContractModalContext';

const GenerateIncentiveOfferPurchaseContractModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useGenerateIncentiveOfferPurchaseContractModal();

  return (
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-outline-light"
        onClick={actions.handleCloseModal}
        disabled={data.isLoading}
        data-testid="generate-purchase-contract-cancel-button"
      >
        {t('Cancel')}
      </button>
      <button
        type="button"
        className="btn btn-primary"
        onClick={actions.handleSave}
        disabled={data.isLoading || !data.templateId}
        data-testid="generate-purchase-contract-save-button"
      >
        {t('Save')}
      </button>
    </Modal.Footer>
  );
};

export default GenerateIncentiveOfferPurchaseContractModalFooter;
